module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-header"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.value.url,
      "disabled": _vm.disabled,
      "placeholder": "Укажите ссылку на статью в elibrary или ссылку на электронный ресурс"
    },
    on: {
      "input": function($event) {
        _vm.setValue('url', arguments[0])
      }
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary load-source",
    attrs: {
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onLoadSource($event)
      }
    }
  }, [_vm._v("\n      Загрузить данные\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "type-select"
  }, _vm._l((_vm.typeOptions), function(option) {
    return _c('md-radio', {
      key: option.key,
      attrs: {
        "value": _vm.value.type,
        "md-value": option.key,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setValue('type', arguments[0])
        }
      }
    }, [_vm._v(_vm._s(option.title))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38131d1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogHeader.vue
// module id = 1005
// module chunks = 1